import { IResponseError } from '@lib/error'
import { IShortlistShareLinkResponse, RequestShortlistShareLinkActionTypes } from '@store/campaigns'

export const requestShortlistShareLink = (campaignId: number) => ({
  payload: {
    campaignId,
  },
  type: RequestShortlistShareLinkActionTypes.REQUEST_SHORTLIST_SHARE_LINK_REQUEST,
})

export const requestShortlistShareLinkSuccess = (
  campaignId: number,
  response: IShortlistShareLinkResponse,
) => ({
  payload: {
    campaignId,
    url: response.url,
  },
  type: RequestShortlistShareLinkActionTypes.REQUEST_SHORTLIST_SHARE_LINK_SUCCESS,
})

export const requestShortlistShareLinkError = (campaignId: number, error: IResponseError) => ({
  payload: {
    campaignId,
    error,
  },
  type: RequestShortlistShareLinkActionTypes.REQUEST_SHORTLIST_SHARE_LINK_ERROR,
})
